export default {
  users: state => state.users,
  userInfos: state => state.userInfos,
  internalUsers: state => state.internalUsers
}
